import axios from '../../../utils/customAxiosUtil';
import {
  ResponseUser,
  UserAccount,
  TokenAccount,
  UserPageData,
  UserPw,
  UpdateData
} from '../models/authModel';

import qs from 'qs';

export const authAPI = {
  usersLogin: async (data: UserAccount) => {
    return await axios.post('api/acnt/jwt/login', data);
  },
  getUserProfile: async (id: number) => {
    return await axios.get(`api/acnt/jwt/profile/${id}`);
  },

  usersLogout: (id: number) => {
    return axios.get(`api/acnt/jwt/logout/${id}`);
  },
  refreshToken: (data: TokenAccount) => {
    return axios.post('api/acnt/jwt/refresh', data);
  },

  getUserPage: async (id: string) => {
    return await axios.get(`api/acnt/cstmr/profile/${id}`);
  },
  updateUser: async (data: UpdateData) => {
    const res = await axios.put('api/acnt/cstmr/profile/update', data);
    return res;
  },
  pwcheck: async (userPswd: string) => {
    return await axios.post('api/acnt/cstmr/profile/pwcheck', { userPswd });
  },
  pwupdate: async (data: UserPw) => {
    return await axios.post('api/acnt/cstmr/profile/pswdupdate', data);
  },
  deletedata: async (id: string) => {
    return await axios.post(`api/acnt/cstmr/profile/delete/${id}`);
  }
};
